module.exports = __webpack_public_path__ + "img/advanced2.4a4b4d53.png";